// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip_tooltip__lKrqH","wrapper":"Tooltip_wrapper__dmIof","text":"Tooltip_text__FuL4K"};